import { cn } from '@/utils/cn'
import { getInitials } from '@/utils/formatters'

interface AvatarProps {
  name: string
  /** Preparado para quando a API expuser foto do colaborador. */
  photoUrl?: string | null
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

const SIZES = {
  sm: 'size-8 text-xs',
  md: 'size-10 text-sm',
  lg: 'size-14 text-base',
  xl: 'size-20 text-xl',
}

export function Avatar({ name, photoUrl, size = 'md', className }: AvatarProps) {
  const classes = cn(
    'grid shrink-0 place-items-center overflow-hidden rounded-full bg-brand/12 font-semibold text-brand-strong',
    SIZES[size],
    className,
  )

  if (photoUrl) {
    return <img src={photoUrl} alt={name} loading="lazy" className={cn(classes, 'object-cover')} />
  }

  return (
    <span className={classes} aria-hidden>
      {getInitials(name)}
    </span>
  )
}
